module.exports = __webpack_public_path__ + "img/gl1.c7b570f6.png";